export default __webpack_public_path__ + "static/media/photo2.913f543d.svg";